module.exports = __webpack_public_path__ + "media/images/leaflet_images/marker-icon-2273e3d8ad9264b7daa5bdbf8e6b47f8.png";